import { render, staticRenderFns } from "./AssignTraineeClass.vue?vue&type=template&id=55203cc2"
import script from "./AssignTraineeClass.vue?vue&type=script&lang=js"
export * from "./AssignTraineeClass.vue?vue&type=script&lang=js"
import style0 from "./AssignTraineeClass.vue?vue&type=style&index=0&id=55203cc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports